<template>
  <div v-if="reportType === ReportType.EXECUTIVE_SUMMARY">
    <div class="subtitle1 mb-4">{{ $t("general.filters") }}</div>
    <v-select
      v-model="model.executiveSummaryFilter.timePeriod"
      class="mb-4"
      :placeholder="$t('reports.executiveSummaryReport.dateRange')"
      :label="$t('reports.executiveSummaryReport.dateRange')"
      :items="dateRangeItems"
      item-title="label"
      item-value="value"
      variant="outlined"
      :return-object="false"
      hide-details
    />

    <v-checkbox v-model="model.executiveSummaryFilter.showZeroValues" hide-details :ripple="false">
      <template #label>
        <span class="body2">{{ $t("reports.executiveSummaryReport.showZeroValues") }}</span>
      </template>
    </v-checkbox>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ReportType, ReportDateRangePreset } from "@/constants/reports.ts";
import {
  defaultScheduledReportFilters,
  type ScheduledReportItemFilters,
} from "@/_store/scheduled-reports/scheduled-reports.module.ts";
import cloneDeep from "lodash/cloneDeep";

export default defineComponent({
  props: {
    reportType: {
      type: String as PropType<ReportType>,
      required: true,
    },
    filters: {
      type: Object as PropType<ScheduledReportItemFilters>,
      default: null,
    },
  },
  emits: ["update:filters"],
  setup(props, { emit }) {
    const { t } = useI18n();

    if (!props.filters) {
      console.error(
        "[ScheduledReportModalFilters] filters prop is missing, falling back to defaults"
      );
    }

    const model = ref<ScheduledReportItemFilters>(
      cloneDeep(props.filters ?? defaultScheduledReportFilters)
    );

    const dateRangeItems = [
      { label: t("dateRangePicker.lastSevenDays"), value: ReportDateRangePreset.LAST_7_DAYS },
      { label: t("dateRangePicker.lastThirtyDays"), value: ReportDateRangePreset.LAST_30_DAYS },
      { label: t("dateRangePicker.lastNinetyDays"), value: ReportDateRangePreset.LAST_90_DAYS },
      { label: t("dateRangePicker.last365Days"), value: ReportDateRangePreset.LAST_365_DAYS },
    ];

    watch(
      model,
      (newVal) => {
        emit("update:filters", newVal);
      },
      { deep: true }
    );

    return {
      model,
      dateRangeItems,
      ReportType,
    };
  },
});
</script>
